import React, { useEffect, useState } from "react";
import Nvabar from "./Nvabar";
import "./HomePage.css";
import Card2 from "./Card2";
import Card3 from "./Card3";
import Card from "./Card";
import { Link, useParams } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";

const HomePage = () => {
  let params = useParams();
  const [Tag, setTag] = useState("Tech");
  const [Tech, setTech] = useState([]);
  const [Health, setHealth] = useState([]);
  const token = Cookies.get("token");

  //api call

  useEffect(() => {
    request("Tech");
    request("Health");
    return;
  }, [token]);

  const request = async (name) => {
    try {
      console.log(process.env.REACT_APP_URL);
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.get(
        `${process.env.REACT_APP_URL}allpost${name}`,
        config
      );
      if (name === "Tech") {
        await setTech(data);
      } else {
        await setHealth(data);
      }
    } catch (err) {
      console.log(err.message);
    }
  };
  return (
    <div>
      <Nvabar />
      <div className="div1">
        <div className="wrapper1">
          <div className="internal1">
            <h1>The AI Revolution is here</h1>
            <p>
              Despite all the excitement surrounding AI, there has been no
              shortage of consternation — from concerns about job displacement,
              the spread of disinformation, and AI-powered cyberattacks all the
              way to fears of existential risk. Although it’s essential to test
              and deploy AI responsibly, it’s unlikely that
            </p>
          </div>
        </div>

        <div className="wrapper2">
          <Link to="/home/Travel">
            <Card2
              Title={"Travel"}
              Image={
                "https://images.pexels.com/photos/3225531/pexels-photo-3225531.jpeg?auto=compress&cs=tinysrgb&w=600"
              }
              Content={"Time for an adventure"}
            />
          </Link>
          <Link to="/home/Health">
            <Card2
              Title={"Health"}
              Image={
                "https://images.pexels.com/photos/6707078/pexels-photo-6707078.jpeg?auto=compress&cs=tinysrgb&w=600"
              }
              Content={"Are you healthy and happy?"}
            />
          </Link>
          <Link to="/Home/Tech">
            <Card2
              Title={"Tech"}
              Image={
                "https://images.pexels.com/photos/2399840/pexels-photo-2399840.jpeg?auto=compress&cs=tinysrgb&w=600"
              }
              Content={"Full of Tech Senses."}
            />
          </Link>
        </div>

        <div className="wrapper3">
          <div className="carding">
            {Tech.slice(0, 5).map((item) => {
              return (
                <Link to={"/read/" + item._id}>
                  <Card3
                    key={item.id}
                    Content={item.Content}
                    Title={item.Title}
                    Tag={item.Tag}
                    image={item.image}
                  />
                </Link>
              );
            })}
          </div>
          <div className="small-carding">
            {Health.slice(0, 5).map((item) => {
              return (
                <Link to={"/read/" + item._id}>
                  <Card
                    key={item.id}
                    Content={item.Content}
                    Title={item.Title}
                    Tag={item.Tag}
                    image={item.image}
                  />
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
